export const FETCH_USER_DATA = "FETCH_USER_DATA";
export const RESET_FETCHED = "RESET_FETCHED";
export const SUBMIT_EMAIL_SUCCESS = "SUBMIT_EMAIL_SUCCESS";
export const SUBMIT_EMAIL_FAIL = "SUBMIT_EMAIL_FAIL";

export const fetchUserData = () => async (dispatch, getState) => {
  // reset previous state
  // dispatch(resetFetched());

  const state = getState();
  const { API_ENDPOINT, userID, token } = state.auth;
  let userData = {};

  try {
    // if logged in, fetch data and save
    if (userID) {
      // fetch data. TODO: condense into one fetch function to reduce server load
      const [
        packagesRes,
        accountRes,
        lockersRes,
        couponRes
      ] = await Promise.all([
        fetch(`${API_ENDPOINT}/api/packages/${userID}?token=${token}`).then(
          res => res.json()
        ),
        fetch(`${API_ENDPOINT}/api/account/${userID}?token=${token}`).then(
          res => res.json()
        ),
        fetch(`${API_ENDPOINT}/api/locations/${userID}?token=${token}`).then(
          res => res.json()
        ),
        fetch(`${API_ENDPOINT}/api/coupons?token=${token}`).then(res =>
          res.json()
        )
      ]);

      userData = {
        packages: packagesRes,
        account: accountRes,
        lockers: lockersRes.status >= 400 ? [] : lockersRes,
        coupons: couponRes.status >= 400 ? [] : couponRes
      };
    }
  } catch (error) {
    console.log(error);
  }

  dispatch({
    type: FETCH_USER_DATA,
    payload: userData
  });
};

export const resetFetched = () => dispatch => {
  dispatch({ type: RESET_FETCHED });
};

export const submitEmail = email => async (dispatch, getState) => {
  let result = {};
  const { API_ENDPOINT } = getState().auth;

  try {
    result = await fetch(`${API_ENDPOINT}/api/addEmail?email=${email}`, {
      method: "post"
    }).then(res => res.json());
  } catch (err) {
    result = err;
  }

  if (result.status <= 400) dispatch({ type: SUBMIT_EMAIL_SUCCESS });
  else dispatch({ type: SUBMIT_EMAIL_FAIL });
};
